var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-item-generator"},[_c('calendar-input',{attrs:{"options":{
      label: 'Date'
    }},on:{"input":function($event){_vm.showRest = true}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),(_vm.showRest)?[_c('text-input',{attrs:{"options":{
        label: 'Publication'
      }},model:{value:(_vm.publication),callback:function ($$v) {_vm.publication=$$v},expression:"publication"}}),_vm._v(" "),_c('text-input',{attrs:{"options":{
        label: 'Title'
      }},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}}),_vm._v(" "),_c('text-input',{attrs:{"options":{
        label: 'Link URL'
      }},model:{value:(_vm.linkUrl),callback:function ($$v) {_vm.linkUrl=$$v},expression:"linkUrl"}}),_vm._v(" "),_c('amazon-media-input',{attrs:{"label":"Image","options":{
        label: 'Upload Image',
        height: 214,
        width: 350,
        straightToData: true
      }},model:{value:(_vm.image),callback:function ($$v) {_vm.image=$$v},expression:"image"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("\n      Copy the below code into the Roscon website CMS:\n    ")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"content"},[_c('pre',[_vm._v("          "+_vm._s(_vm.code)+"\n        ")])])])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39b7bf94","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/MediaItem.vue
// module id = 1399
// module chunks = 1